/* eslint-disable */
import React, { useContext, useEffect, useLayoutEffect, useRef } from "react";
import { Outlet, useLocation, useSearchParams } from "react-router-dom";
import { Header } from "components/Header";
import { BottomNavMenu } from "components/BottomNavMenu";
import { SideNavMenu } from "components/SideNavMenu";
import { CommonContext } from "contexts/CommonContext";
import styles from "./MenuWithHeaderLayout.module.scss";
import { pushToDataLayer, isStandalone } from "core/utils/utils.helper";
import { isAppleDevice } from "helpers/userAgent";
import useAuth from "hooks/useAuth";
import { useGuidanceStore } from "@/stores/guidanceStore";
import { handleUtmFunctions } from "helpers/common.helper";
import Layout from "antd/es/layout";
import { AuthModalProvider } from "@/contexts/AuthModalContext";
import { PushNotificationManager } from "components/PushNotificationManager";

export const MenuWithHeaderLayout: React.FC = () => {
  const { isTablet, setMobileRef } = useContext(CommonContext); // Detect if the device is tablet
  const { pathname } = useLocation();
  const contentRef = useRef<HTMLDivElement>(null);
  let [searchParams] = useSearchParams();
  const setProgressValue = useGuidanceStore((state) => state.setProgressValue); // Zustand store - replaces useSetRecoilState(guidanceDetailsProgressAtom)
  const auth: any = useAuth(); // Access authentication context
  const isLoggedIn: boolean = auth && auth.isAuthenticated; // Check if user is authenticated
  const isIOSApp = isAppleDevice() && isStandalone();

  //notification and product referrer related tracking mechanism using utm paramter
  useEffect(() => {
    searchParams && handleUtmFunctions(searchParams);
  }, [searchParams]);

  useLayoutEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [pathname, contentRef]);

  useEffect(() => {
    // Log page view event to the data layer
    pushToDataLayer({
      event: "PAGE_VIEW",
      user_status: isLoggedIn,
      event_type: "pageview",
    });
    //set guidance details progress to "0" everytime route changes
    setProgressValue(0);
  }, [pathname, isLoggedIn, setProgressValue]);

  useEffect(() => {
    contentRef.current && setMobileRef(contentRef);
  }, [contentRef, setMobileRef]);

  return (
    <div className={styles.app_container_header}>
      {!isIOSApp && <PushNotificationManager />}{" "}
      {/* Manages push notification modals */}
      <Header /> {/* Render header */}
      <div
        className={`${styles.outlet_container} ${styles.container_fluid} ${isTablet && styles.outlet_container__device_overflow}`}
      >
        {!isTablet ? (
          <Layout className={styles.desktop_container}>
            <SideNavMenu /> {/* Render side navigation for desktop */}
            <Layout.Content>
              <div
                className={styles.content_wrapper}
                id="content_area"
                ref={contentRef}
              >
                <AuthModalProvider>
                  <Outlet /> {/* Render child routes */}
                </AuthModalProvider>
              </div>
            </Layout.Content>
          </Layout>
        ) : (
          <div
            className={styles.mobile_container}
            id="content_area"
            ref={contentRef}
          >
            <AuthModalProvider>
              <Outlet /> {/* Render child routes for mobile */}
            </AuthModalProvider>
          </div>
        )}
      </div>
      {isTablet ? <BottomNavMenu /> : ""} {/* Render bottom nav for tab */}
    </div>
  );
};
